import type { HttpAdapterConfig } from "@/shared/libs/http/interface";
import { AxiosAdapter } from "@/shared/libs/http/axios/AxiosFetcher";
import HttpAdapterImpl from "@/shared/libs/http/HttpAdapter";

export class HttpAdapterBuilder {
    static build = (config: HttpAdapterConfig) => {
        const axiosAdapter = new AxiosAdapter(config.interceptors);
        return new HttpAdapterImpl(axiosAdapter);
    };
}
